import React, { Component } from 'react';
import {
  Col, FormGroup, Input, Label, Row,
} from 'reactstrap';
import { Translate, withLocalize } from 'react-localize-redux';
import PropTypes from 'prop-types';
import { countries } from '../helpers/countries';


class Location extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);

    this.state = {
      clicked: false,
    };
  }

  handleClick() {
    this.setState({
      clicked: true,
    });
  }

  render() {
    const {
      activeLanguage,
      country,
      isSubmitted,
      handleChange,
      location,
      validateCountry,
      validateLocation,
    } = this.props;

    const { clicked } = this.state;

    const placeholder = activeLanguage.code === 'gb'
      ? 'City/Town/Village' : 'Ville/Village';

    const countryListFr = countries.slice(2).sort((a,b) =>
    (a.translations.fr > b.translations.fr) ? 1
    : ((b.translations.fr > a.translations.fr) ? -1 : 0));
    const countryListEl = activeLanguage.code === 'gb'
      ? countries
      : countries.slice(0, 2).reverse().concat(countryListFr);


    const countryList = countryListEl.map((c) => (
      <option
        value={c.name}
        key={c.name}
      >
        {activeLanguage.code === 'gb'
          ? c.name : c.translations.fr }
      </option>
    ));

    return (
      <Row form>
        <Col md={6} lg={3}>
          <FormGroup>
            <Label className="sm-text" for="location"><Translate id="location" /></Label>
            <Input
              id="location"
              type="text"
              placeholder={placeholder}
              valid={validateLocation()}
              invalid={(!validateLocation() && clicked)
                || (!validateLocation() && isSubmitted)}
              value={location}
              onChange={handleChange}
              onClick={this.handleClick}
            />
          </FormGroup>
          {(!validateLocation() && isSubmitted)
            && <p><Translate id="required" /></p>}
        </Col>

        <Col md={6} lg={3}>
          <FormGroup>
            <Label className="sm-text" for="country"><Translate id="country" /></Label>
            <Input
              type="select"
              id="country"
              valid={validateCountry()}
              invalid={(!validateCountry() && clicked)
                || (!validateCountry() && isSubmitted)}
              value={country}
              onChange={handleChange}
            >
              <option value="">
                {activeLanguage.code === 'gb' ? 'Select an option' : 'Sélectionnez une option'}
              </option>

              {countryList}
            </Input>
          </FormGroup>
          {(!validateCountry() && isSubmitted)
            && <p><Translate id="required" /></p>}
        </Col>
      </Row>
    );
  }
}

Location.propTypes = {
  activeLanguage: PropTypes.shape({
    code: PropTypes.string.isRequired,
  }).isRequired,
  country: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  isSubmitted: PropTypes.bool.isRequired,
  location: PropTypes.string.isRequired,
  validateCountry: PropTypes.func.isRequired,
  validateLocation: PropTypes.func.isRequired,
};

export default withLocalize(Location);
